module.exports = {"pagination":{}}


//////////////////
// WEBPACK FOOTER
// ./~/aws-sdk/apis/waf-2015-08-24.paginators.json
// module id = 1451
// module chunks = 0